import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

const NotFound = () => {
  return (
    <Wrapper>
    <div className="not-found">
      <h1>404</h1>
      <p>Sorry, the page you are looking for does not exist.</p>
      <NavLink to="/">Go Back to Home</NavLink>
    </div>
    </Wrapper>
  );
};
const Wrapper = styled.section`
 .not-found {
  text-align: center;
  margin-top: 50px;
}

.not-found h1 {
  font-size: 5rem;
  color: #ff6f61;
}

.not-found p {
  font-size: 1.5rem;
  margin-bottom: 20px;
}

.not-found a {
  text-decoration: none;
  color: #007bff;
  font-weight: bold;
}

.not-found a:hover {
  text-decoration: underline;
}

`



export default NotFound;
